// Канонический словарь «тип операции кассы → приход/расход» — ЕДИНСТВЕННЫЙ
// источник правила (правило 1 «Single source of truth», план 2026-06-12 §6.4,
// карточка cashbox-optype-direction). До карточки правило жило в трёх
// несогласованных местах: OP_TYPES_IN/OUT в admin DealBlock.tsx, regex
// /расход|возврат|выдач/ в cashboxCsv.service.ts и хардкоды у серверных
// писателей (delivery.service.ts). Потребители словаря:
//   - apps/api services/cashbox.service.ts — сервер сам проставляет direction
//     по opType (клиентское поле игнорируется для известных типов);
//   - apps/api services/cashboxCsv.service.ts — CSV-импорт (старый regex
//     остался только фолбэком для неизвестных opType);
//   - apps/api services/delivery.service.ts — операция выдачи (pickup);
//   - apps/api bot/handlers/cashboxIntake.ts — выравнивание AI-направления;
//   - apps/admin .../cashbox/DealBlock.tsx — форма операции и dir-pill.
//
// В прод-БД существуют операции с произвольными opType (колонка «Счет» старых
// CSV — свободный текст): для них deriveDirection возвращает null, НЕ expense —
// направление таких строк задаётся явно и никогда не пересчитывается задним
// числом. Никаких миграций/бэкфиллов эта карточка не делает.
// Служебный тип: операцию с ним пишет сканер выдачи (delivery.service.ts,
// defaultPushCashbox) — деньги, принятые при выдаче заказа, т.е. приход.
// Решение владельца 2026-06-13 (§11): переименован на русский. Легаси-алиас
// "pickup" остаётся в словаре читателем (стенд/история могли успеть записать
// английское имя), но писатель и форма используют только русское.
export const CASHBOX_PICKUP_OP_TYPE = "Выручка (выдача)";
export const CASHBOX_PICKUP_OP_TYPE_LEGACY = "pickup";
// Порядок ключей повторяет порядок выпадающего списка формы админки
// (приход, затем расход) — на нём построены CASHBOX_FORM_OP_TYPES_*.
export const OP_TYPE_DIRECTION = {
    Выручка: "income",
    Внесение: "income",
    Изъятие: "expense",
    Расход: "expense",
    ТНВТ: "expense",
    "Оплата курьеру": "expense",
    "Офисные расходы": "expense",
    "Забор/доставка": "expense",
    Обрешетка: "expense",
    Упаковка: "expense",
    Другое: "expense",
    "Выручка (выдача)": "income",
    // Легаси-алиас служебного типа выдачи (до переименования 2026-06-13).
    pickup: "income",
};
export const CASHBOX_OP_TYPES = Object.keys(OP_TYPE_DIRECTION);
// Служебные типы пишутся системой и в ручной форме админки не предлагаются.
export const CASHBOX_SERVICE_OP_TYPES = [
    CASHBOX_PICKUP_OP_TYPE,
    CASHBOX_PICKUP_OP_TYPE_LEGACY,
];
// Списки для ручной формы (admin DealBlock): словарь минус служебные типы,
// разбитый по направлению. Порядок — порядок ключей словаря.
export const CASHBOX_FORM_OP_TYPES_IN = CASHBOX_OP_TYPES.filter((opType) => OP_TYPE_DIRECTION[opType] === "income" && !CASHBOX_SERVICE_OP_TYPES.includes(opType));
export const CASHBOX_FORM_OP_TYPES_OUT = CASHBOX_OP_TYPES.filter((opType) => OP_TYPE_DIRECTION[opType] === "expense" && !CASHBOX_SERVICE_OP_TYPES.includes(opType));
/**
 * Выводит направление операции из её opType по каноническому словарю.
 * Для неизвестных строк (легаси-операции из старых CSV-импортов) возвращает
 * null — направление таких операций задаётся явно, деградация в expense
 * запрещена (иначе поедет пересчёт балансов; см. риски карточки §6.4).
 */
export function deriveDirection(opType) {
    // hasOwnProperty: opType — свободный текст из БД/CSV, защищаемся от
    // ключей прототипа ("constructor", "toString", …).
    if (!Object.prototype.hasOwnProperty.call(OP_TYPE_DIRECTION, opType))
        return null;
    return OP_TYPE_DIRECTION[opType];
}
//# sourceMappingURL=opTypes.js.map